import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { Button } from "@mui/material";
import { useGridSelection } from "hooks/omnisearch-v2";
import { useState } from "react";

import { DiscrepancyReviewDialog } from "./DiscrepancyReviewDialog";
import { selectedManifestIds } from "./manifestsV3Selection";

/**
 * V2's bulk "Review Discrepancies" action on the merged list.
 *
 * The ids handed to the dialog are the selected manifest ids, including ones
 * selected on another page or search (see `selectedManifestIds`), and never a
 * bill of lading. The count on the button describes the same list.
 *
 * Reads the selection through `useGridSelection` rather than a controlled
 * selection model, so selecting rows re-renders this button alone instead of
 * the whole page. The ids are read during render (not memoized): the hook
 * re-renders this component on every selection change, which is exactly when
 * this list changes.
 */
export function BulkReviewDiscrepanciesButton() {
  const { getSelectedIds } = useGridSelection();
  const [reviewIds, setReviewIds] = useState<string[] | null>(null);

  const manifestIds = selectedManifestIds(getSelectedIds());

  return (
    <>
      {manifestIds.length > 0 && (
        <Button
          variant="outlined"
          color="staff"
          startIcon={<CompareArrowsIcon />}
          onClick={() => setReviewIds(manifestIds)}
        >
          Review Discrepancies ({manifestIds.length})
        </Button>
      )}
      {reviewIds && (
        <DiscrepancyReviewDialog
          processedManifestIds={reviewIds}
          onClose={() => setReviewIds(null)}
        />
      )}
    </>
  );
}
